import { render, staticRenderFns } from "./NewReward.vue?vue&type=template&id=68b89973&scoped=true"
import script from "./NewReward.vue?vue&type=script&lang=js"
export * from "./NewReward.vue?vue&type=script&lang=js"
import style0 from "./NewReward.vue?vue&type=style&index=0&id=68b89973&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b89973",
  null
  
)

export default component.exports